export default __webpack_public_path__ + "static/media/logo.203d24e2.svg";